import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Select } from '@ngxs/store';
import { Observable, Subscription } from 'rxjs';
import { TypeConteneurMobileDto, ZoneGeographiqueDto } from 'src/api/models';
import { ControlPanelStore } from 'src/states/control-panel.store';

@Component({
  selector: 'app-type-conteneur-mobile',
  templateUrl: './type-conteneur-mobile.component.html',
  styleUrls: ['./type-conteneur-mobile.component.css']
})
export class TypeConteneurMobileComponent implements OnInit, OnDestroy {

  @Select(ControlPanelStore.typesConteneursMobiles$) typesConteneursMobiles$: Observable<TypeConteneurMobileDto[]>;

  @Input('typeConteneurMobileId') public typeConteneurMobileId: number;

  TypeInComponent: TypeConteneurMobileDto;

  tc: Subscription;

  constructor() { }

  ngOnInit() {
    this.tc = this.typesConteneursMobiles$.subscribe(res => {
      if (res != null) {
        let type = res.filter(u => u.Id == this.typeConteneurMobileId);
        this.TypeInComponent = type.length == 1 ? type[0] : { Nom: null };
      }
    });
  }

  ngOnDestroy() {
    this.tc?.unsubscribe();
  }
}
